<template>
  <div>
    <!-- <v-toolbar color="primary">
        <v-card-title class="pl-0">
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
      </v-toolbar> -->

    <v-container class="pa-0">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="editedItem.name"
            :hide-details="true"
            label="Name"
            @change="enableGuardOnChanges"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-select
            :items="getMediaTypes"
            v-model="editedItem.mediaTypeId"
            label="Media Type"
            item-text="label"
            item-value="value"
            :hide-details="true"
            :disabled="true"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-select
            :items="langOptions"
            item-text="name"
            item-value="id"
            label="Language"
            outlined
            v-model="editedItem.langId"
            :menu-props="{ top: false, offsetY: true }"
            class="mx-0 mb-3"
            hide-details="auto"
            @change="enableGuardOnChanges"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="12" sm="12" md="12">
          <v-tabs
            v-if="false"
            background-color="#272727"
            v-model="imageAssetTabActive"
          >
            <!-- <v-tabs-slider></v-tabs-slider> -->
            <v-tab
              class="primary--text"
              :key="1"
              :href="`#image-asset-tab-file`"
            >
              <v-icon class="mr-2 primary--text text-h6"
                >mdi-file-plus-outline</v-icon
              >
              File
            </v-tab>
            <v-tab
              class="primary--text"
              :key="2"
              :href="`#image-asset-tab-url`"
            >
              <v-icon class="mr-2 primary--text text-h6">mdi-link</v-icon>
              URL
            </v-tab>

            <v-tab-item :key="1" :value="'image-asset-tab-url'">
              <v-card flat class="mx-auto pt-10">
                <v-img
                  :src="imageData"
                  max-height="400"
                  contain
                  class="grey darken-4 black--text align-end"
                ></v-img>
                <v-card-actions>
                  <v-text-field
                    v-model="editedItem.url"
                    label="URL"
                    @input="onUrlFieldChange"
                  ></v-text-field>
                </v-card-actions>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="2" :value="'image-asset-tab-file'">
              <upload-dialog
                :showDialog="uploadDialogVisible"
                @done="uploadDialogOnDone"
                @cancel="uploadDialogOnCancel"
              ></upload-dialog>
              <v-card flat class="mx-auto pt-5 pb-5">
                <div
                  @drop.prevent="addFile"
                  @dragover.prevent
                  class="drop-area"
                >
                  <span>Drop a file to upload</span>
                  <span>or</span>
                  <v-btn small @click="upload" class="mr-2">
                    Select a file to upload
                    <v-icon right>mdi-file-plus-outline</v-icon>
                  </v-btn>
                </div>
                <v-dialog
                  persistent
                  v-model="dialog"
                  v-if="isDzi"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      class="mt-3"
                      small
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="openPolygonsEditor()"
                    >
                      Edit link areas
                      <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <v-card height="100%">
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Edit link areas</v-toolbar-title>
                      <v-select
                        v-if="selectedPolygon"
                        :items="poisParentsChildrenRecs"
                        v-model="selectedRecord.id"
                        item-value="id"
                        label="Linked record"
                        dense
                        :return-object="true"
                        @change="onChildRecordSelectChange($event)"
                      >
                        <template v-slot:selection="{ item }">
                          {{ item.name }} - {{ item.type }}
                        </template>
                        <template v-slot:item="{ item }">
                          {{ item.name }} - {{ item.type }}
                        </template>
                      </v-select>
                      <v-spacer></v-spacer>

                      <v-toolbar-items>
                        <v-btn dark text @click="savePolygons()">Save</v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                    <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                    <open-sea-dragon-viewer
                      ref="osdViewerRef"
                      :id="'osd-viewer'"
                      :options="{
                        defaultZoomLevel: 1,
                        minZoomLevel: 1,
                        maxZoomLevel: 5,
                        ajaxWithCredentials: false,
                        showNavigator: false,
                        showNavigationControl: false,
                        showReferenceStrip: false,
                        homeFillsViewer: true,
                        constrainDuringPan: true,
                        visibilityRatio: 1,
                        iOSDevice: true,
                        loadTilesWithAjax: true,
                        ajaxWithCredentials: true,
                        //ajaxHeaders: {
                        // Example of using the viewer-level ajaxHeaders option
                        // for providing an authentication token.
                        //  Authorization: 'Bearer ' + token
                        //},
                        animationTime: 0.5,
                        immediateRender: true
                      }"
                      :tile-sources="currentTileSources"
                      :polygonsData="polygonsData"
                      @selected="onSelection"
                      @deselected="onDeselection"
                    />
                  </v-card>
                </v-dialog>
                <v-img
                  :src="imageData"
                  max-height="400"
                  contain
                  class="grey darken-4 black--text align-end mt-3"
                ></v-img>
              </v-card>
            </v-tab-item>
          </v-tabs>
          <template v-else-if="imageAssetTabActive === 'image-asset-tab-url'">
            <v-card flat class="mx-auto pt-10">
              <v-img
                :src="imageData"
                max-height="400"
                contain
                class="grey darken-4 black--text align-end"
              ></v-img>
              <v-card-actions>
                <v-text-field
                  v-model="editedItem.url"
                  label="URL"
                  @input="onUrlFieldChange"
                ></v-text-field>
              </v-card-actions>
            </v-card>
          </template>
          <template v-else>
            <upload-dialog
              :showDialog="uploadDialogVisible"
              @done="uploadDialogOnDone"
              @cancel="uploadDialogOnCancel"
            ></upload-dialog>
            <v-card flat class="mx-auto pt-5 pb-5">
              <div @drop.prevent="addFile" @dragover.prevent class="drop-area">
                <span>Drop a file to upload</span>
                <span>or</span>
                <v-btn small @click="upload" class="mr-2">
                  Select a file to upload
                  <v-icon right>mdi-file-plus-outline</v-icon>
                </v-btn>
              </div>
              <v-dialog
                persistent
                v-model="dialog"
                v-if="isDzi"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="mt-3"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="openPolygonsEditor()"
                  >
                    Edit link areas
                    <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <v-card height="100%">
                  <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Edit link areas</v-toolbar-title>
                    <v-select
                      v-if="selectedPolygon"
                      :items="poisParentsChildrenRecs"
                      v-model="selectedRecord.id"
                      item-value="id"
                      label="Linked record"
                      dense
                      :return-object="true"
                      @change="onChildRecordSelectChange($event)"
                    >
                      <template v-slot:selection="{ item }">
                        {{ item.name }} - {{ item.type }}
                      </template>
                      <template v-slot:item="{ item }">
                        {{ item.name }} - {{ item.type }}
                      </template>
                    </v-select>
                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                      <v-btn dark text @click="savePolygons()">Save</v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                  <open-sea-dragon-viewer
                    ref="osdViewerRef"
                    :id="'osd-viewer'"
                    :options="{
                      defaultZoomLevel: 1,
                      minZoomLevel: 1,
                      maxZoomLevel: 5,
                      ajaxWithCredentials: false,
                      showNavigator: false,
                      showNavigationControl: false,
                      showReferenceStrip: false,
                      homeFillsViewer: true,
                      constrainDuringPan: true,
                      visibilityRatio: 1,
                      iOSDevice: true,
                      loadTilesWithAjax: true,
                      ajaxWithCredentials: true,
                      //ajaxHeaders: {
                      // Example of using the viewer-level ajaxHeaders option
                      // for providing an authentication token.
                      //  Authorization: 'Bearer ' + token
                      //},
                      animationTime: 0.5,
                      immediateRender: true
                    }"
                    :tile-sources="currentTileSources"
                    :polygonsData="polygonsData"
                    @selected="onSelection"
                    @deselected="onDeselection"
                  />
                </v-card>
              </v-dialog>
              <v-img
                :src="imageData"
                max-height="400"
                contain
                class="grey darken-4 black--text align-end mt-3"
              ></v-img>
            </v-card>
          </template>
        </v-col>
      </v-row>
      <v-row class="pl-3">
        <router-link
          style="text-decoration: none; color: inherit"
          :to="{ name: 'Media Manager Edit Links' }"
        >
          <v-btn small color="primary darken-1">
            MANAGE PARENT LINKS
            <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
          </v-btn>
        </router-link>
      </v-row>
      <v-row>
        <v-card flat class="flex-grow-1">
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <media-manager-list
                  :mediaId="editedItem.id"
                  @deletedRecords="setDeletedRecordList"
                ></media-manager-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row
        v-if="
          editedItem.mediaTypeId === enums.MediaType.poi_title ||
            editedItem.mediaTypeId === enums.MediaType.project_title ||
            editedItem.mediaTypeId === enums.MediaType.menu_item_title ||
            editedItem.mediaTypeId === enums.MediaType.unity_language_config
        "
      >
        <v-col cols="12" sm="6" md="12">
          <v-textarea
            rows="6"
            outlined
            v-model="editedItem.textualContent"
            label="Textual content"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row
        v-if="
          editedItem.mediaTypeId === enums.MediaType.description ||
            editedItem.mediaTypeId === enums.MediaType.project_text_description
        "
      >
        <v-col cols="12" sm="6" md="12">
          <editor
            v-model="editedItem.textualContent"
            :init="{
              invalid_styles: {
                table: 'height',
                tr: 'width height',
                th: 'width height',
                td: 'width height'
              },
              height: 550,
              menubar: true,
              plugins: [
                'advlist autolink lists link',
                'searchreplace visualblocks',
                'insertdatetime table paste code'
              ],
              table_default_attributes: {
                border: '0'
              },
              table_default_styles: {
                width: '100%'
              },
              menubar: false,
              toolbar:
                'undo redo | table | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code'
            }"
          />
        </v-col>
      </v-row>
      <v-row class="mt-0" v-if="isSuperAdmin">
        <!--            <v-col cols="12" sm="6" md="3">-->
        <!--              <v-text-field label="Media Data" solo readonly></v-text-field>-->
        <!--            </v-col>-->
        <v-col cols="12" sm="6" md="12">
          <v-card>
            <v-card-title>Media Data</v-card-title>
            <v-jsoneditor
              v-model="editedItem.mediaData"
              :plus="true"
              height="300px"
              @onChangeText="onJsonEditorChange"
              :options="{ mode: 'text' }"
            ></v-jsoneditor>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-card-actions class="mt-2 px-0">
      <v-btn color="#FF5252" small @click="deleteMedia">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="darken-1" small @click="cancel">Cancel</v-btn>
      <v-btn color="blue darken-1" small @click="save">Save</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
//import UploadDialog from '../components/UploadDialog'
import VJsoneditor from 'v-jsoneditor/src/index'
import Enums from '../helpers/Enums'
import { FilesGetMixin } from '../mixins/FilesGetMixin'
import UploadDialog from './UploadDialog'
import OpenSeadragonMixin from '../mixins/OpenSeadragonMixin'
import OpenSeaDragonViewer from '../components/Polygons/OpenSeadragonViewer'
import Editor from '@tinymce/tinymce-vue'
import MediaManagerList from '../components/RecordLists/MediaManagerList.vue'

export default {
  mixins: [FilesGetMixin, OpenSeadragonMixin],
  components: {
    UploadDialog,
    VJsoneditor,
    'open-sea-dragon-viewer': OpenSeaDragonViewer,
    editor: Editor,
    MediaManagerList
  },
  computed: {
    langOptions() {
      let arr = []
      Object.entries(Enums.lang).forEach(([key, value]) => {
        if (this.projectLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectLangs() {
      if (this.$store.state.ProjectStore.projectConfig) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.selectedLangs
      }
      return null
    },
    isSuperAdmin() {
      return this.$store.state.UserStore.userRole[0] === 'super_admin'
    },
    getMediaTypes() {
      let arr = []
      for (var i = 0; i < this.$store.state.MediaStore.mediaTypes.length; i++) {
        let obj = {
          value: this.$store.state.MediaStore.mediaTypes[i].typeId,
          label: this.$t(
            'mediaTypes.' + this.$store.state.MediaStore.mediaTypes[i].name
          )
        }
        arr.push(obj)
      }
      return arr
    },
    // formTitle() {
    //   return this.editedIndex === -1 ? "New Media" : "Edit Media";
    // },
    imageAssetTabActive: {
      get: function() {
        let retVal = 'image-asset-tab-url'
        if (this.mediaAssetType === Enums.MediaAssetType.image_path) {
          retVal = 'image-asset-tab-file'
        }
        // if (this.editedItem.path && this.editedItem.path !== '') {
        //   retVal = 'image-asset-tab-file'
        // }
        console.log('editedItem', this.editedItem, retVal)
        return retVal
      },
      set: function(newVal) {
        this.changeMediaAssetType(newVal)
      }
    },
    currentFile: {
      get: function() {
        return new File([this.editedItem.path], this.editedItem.path, [
          {
            type: `text/${this.editedItem.path.substring(
              this.editedItem.path.lastIndexOf('.') + 1,
              this.editedItem.path.length
            )}`
          }
        ])
      },
      set: function(newValue) {
        console.log(newValue)
      }
    },
    // imageData: {
    //   get: function() {
    //     let retVal = ''
    //     this.getImage(this.editedItem).then(r => {
    //       retVal = r
    //     })
    //     return retVal
    //   }
    // }
    getContextTitle() {
      if (this.$store.state.MasterplanStore.selectedMasterplan) {
        if (
          this.$store.state.MasterplanStore.selectedMasterplan.parentId !== 0
        ) {
          return null
        } else {
          return 'community'
        }
      } else {
        return 'masterplan'
      }
    }
  },
  props: {
    // showDialog: {
    //   type: Boolean,
    //   required: true,
    //   default: false,
    // },
    // editedItem: {
    //   type: Object,
    //   required: true,
    //   default: function() {
    //     return {
    //       name: "New Media Item",
    //       mediaTypeId: 0,
    //       textualContent: "",
    //       mediaData: "",
    //       path: "",
    //       url: "",
    //       parentGalleryId: 0,
    //       poiId: 0,
    //       langId: 1,
    //     };
    //   },
    // },
    // editedIndex: {
    //   type: Number,
    //   required: false,
    //   default: -1,
    // },
    poisParentsChildrenRecs: {
      type: Array,
      required: false
    }
  },

  created: function() {
    this.editedItem = this.$store.state.MediaManagerStore.selectedMediaItem
  },
  data() {
    return {
      initialTitle: this.$store.state.MediaManagerStore.selectedMediaItem.name,
      langId: this.$store.state.MediaManagerStore.selectedMediaItem.langId,
      mediaData: this.$store.state.MediaManagerStore.selectedMediaItem
        .mediaData,
      path: this.$store.state.MediaManagerStore.selectedMediaItem.path,
      fileTypes: ['all', 'audio', 'video', 'image', 'data', 'text', 'gallery'],
      editedItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: '',
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: 1,
        projectId: 0
      },
      displayed: true,
      text: 'hello!',
      tabs: 2,
      tab: null,
      enums: Enums,
      imageAssetTab: 'image-asset-tab-file',
      imageData: '',
      uploadDialogVisible: false,
      mediaAssetType: Enums.MediaAssetType.image_path,
      isDzi: false,
      currentTileSources: null,
      dialog: false,
      token: null,
      selectedRecord: null,
      selectedPolygon: null,
      polygonsData: null,
      deletedRecords: []
    }
  },

  watch: {
    // showDialog(newValue) {
    //   this.imageData = "";
    //   this.displayed = newValue;
    // },
    editedItem: {
      deep: true,
      handler: function(newMedia, oldVal) {
        this.enableGuardOnChanges()

        console.log('watch.editedItem', newMedia, this.mediaAssetType)

        this.mediaAssetType = Enums.MediaAssetType.image_path
        if (newMedia.path && newMedia.path !== '') {
          this.mediaAssetType = Enums.MediaAssetType.image_path
        } else if (newMedia.url && newMedia.url !== '') {
          this.mediaAssetType = Enums.MediaAssetType.image_url
        }

        this.refreshImage(newMedia)

        this.isDzi = this.isMediaDzi(this.editedItem)

        console.log('media item: ', this.editedItem)

        console.log('is dzi ', this.isDzi)

        if (this.isDzi) {
          this.currentTileSources = this.getOsdTileSources([this.editedItem])
          this.token = localStorage.apiCredentials
        }
      }
    }
  },
  methods: {
    setDeletedRecordList(list) {
      this.deletedRecords = list
    },
    async deleteMedia() {
      await this.$confirm({
        title: 'Confirm delete',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
      await this.$store.dispatch('MediaManagerStore/deleteMedia', [
        this.editedItem.id
      ])
      this.$router.go(-1)
      // .catch(n => {
      //   console.log('NO')
      //   //this.close()
      // })
    },
    addFile(files) {
      let fileList = files.dataTransfer.files
      if (
        fileList === null ||
        typeof fileList === 'undefined' ||
        !fileList.length
      ) {
        return
      }
      const formData = new FormData()
      for (let i = 0; i < fileList.length; i++) {
        formData.append(`file${i}`, fileList[i], fileList[i].name)
      }
      this.$store
        .dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        .then(res => {
          console.log(res)
          this.uploadDialogOnDone(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // close() {
    //   this.displayed = false;
    //   this.$emit("close");
    // setTimeout(() => {
    //   this.editedItem = Object.assign({}, this.defaultItem)
    //   this.editedIndex = -1
    // }, 300)
    // },
    async cancel() {
      this.$router.go(-1)
    },
    async save() {
      this.$store.dispatch('disableGuardBeforeLeave')
      this.editedItem.projectId = this.$store.state.ProjectStore.selectedProject.id
      if (this.mediaAssetType === Enums.MediaAssetType.image_url) {
        this.editedItem.path = ''
      } else {
        this.editedItem.url = ''
      }
      let params = {
        mediaData: this.editedItem,
        delete: this.deletedRecords
      }
      let res = await this.$store.dispatch(
        'MediaManagerStore/updateMedia',
        params
      )
      let params2 = {
        langId: 0,
        search: null,
        mediaTypeId: 2
      }
      this.$router.go(-1)
    },
    upload() {
      console.log('upload')
      this.uploadDialogVisible = true
    },
    onJsonEditorChange(newJson) {
      console.log(newJson)
      //this.editedItem.mediaData = newJson
    },
    uploadDialogOnDone(newValue) {
      this.uploadDialogVisible = false
      if (
        newValue.data &&
        Array.isArray(newValue.data) &&
        newValue.data.length > 0
      ) {
        if (newValue.data.length > 1) {
          console.warn('Uploaded more than one file, not implemented yet :-(')
        }
        this.editedItem.name = newValue.data[0].name
        this.editedItem.path = newValue.data[0].tempName
        this.getUpload(this.editedItem.path).then(r => {
          this.imageData = r
        })
      }
      this.enableGuardOnChanges()
    },
    uploadDialogOnCancel() {
      this.uploadDialogVisible = false
    },
    changeMediaAssetType(newVal) {
      console.log('changeMediaAssetType', newVal)
      if (newVal === 'image-asset-tab-url') {
        this.mediaAssetType = Enums.MediaAssetType.image_url
      } else if (newVal === 'image-asset-tab-file') {
        this.mediaAssetType = Enums.MediaAssetType.image_path
      }
      this.refreshImage(this.editedItem)
    },
    refreshImage(newMedia) {
      console.log('refreshImage', this.mediaAssetType)
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_path &&
        newMedia.path
      ) {
        this.getFile(newMedia).then(r => {
          if (
            newMedia.mediaTypeId === Enums.MediaType.menu_item_image ||
            newMedia.mediaTypeId === Enums.MediaType.project_title_image ||
            newMedia.mediaTypeId === Enums.MediaType.poi_image
          ) {
            this.imageData = r
          }
        })
      } else {
        this.imageData = ''
      }
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_url &&
        newMedia.url
      ) {
        this.imageData = newMedia.url
      } else {
        this.imageData = ''
      }
    },
    onUrlFieldChange(newValue) {
      this.refreshImage(this.editedItem)
    },
    openPolygonsEditor() {
      let self = this
      this.dialog = true
      // HACK - to make sure refs are instantiated
      //
      if (
        Object.prototype.hasOwnProperty.call(
          self.editedItem.mediaData,
          'polygons'
        )
      ) {
        // self.$refs['osdViewerRef'].importFromJSON(
        //   self.editedItem.mediaData['polygons']
        // )
        self.polygonsData = self.editedItem.mediaData['polygons']
      } else {
        self.polygonsData = []
      }
    },
    savePolygons() {
      console.log('REF: ', this.$refs['osdViewerRef'])
      let data = this.$refs['osdViewerRef'].exportToJSON()
      if (this.editedItem.mediaData['polygons'] !== undefined) {
        this.editedItem.mediaData['polygons'] = data
      } else {
        this.editedItem.mediaData = Object.assign(this.editedItem.mediaData, {
          polygons: data
        })
      }
      this.dialog = false
      console.log('project saved! ', data)
    },
    onSelection(value) {
      console.log('SELECTED: ', value)
      this.selectedPolygon = value
      this.selectedRecord = value.data.linkedRecord
    },
    onDeselection() {
      console.log('DESELECTED.')
      this.selectedPolygon = null
    },
    onChildRecordSelectChange(selectedItem) {
      let self = this
      this.selectedRecord = selectedItem
      this.selectedPolygon.data.linkedRecord = {
        id: self.selectedRecord.id,
        type: self.selectedRecord.type
      }
    },
    enableGuardOnChanges() {
      if (
        this.initialTitle !==
          this.$store.state.MediaManagerStore.selectedMediaItem.name ||
        this.langId !==
          this.$store.state.MediaManagerStore.selectedMediaItem.langId ||
        this.mediaData !==
          this.$store.state.MediaManagerStore.selectedMediaItem.mediaData ||
        this.path !== this.$store.state.MediaManagerStore.selectedMediaItem.path
      ) {
        if (!this.$store.getters.guardBeforeLeaveEnabled)
          this.$store.dispatch('enableGuardBeforeLeave')
      } else {
        this.$store.dispatch('disableGuardBeforeLeave')
      }
    }
  }
}
</script>
<style media="screen">
.drop-area {
  width: 100%;
  border: 4px dashed #ffffff;
  box-sizing: border-box;
  margin-top: 20px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
